import uuid from 'react-uuid'

export const NOTE_ACTION_OPTIONS = [
  {
    id: uuid(),
    label: 'Edit note',
    value: 'edit note',
  },
  {
    id: uuid(),
    label: 'Open note',
    value: 'open note',
  },
  {
    id: uuid(),
    label: 'Delete',
    value: 'delete',
  },
]

export const NOTE_ALERT_TYPES = {
  NOTE: 'notes',
  PROPERTIES: 'properties',
}
export const BADGE_DEFAULT_VALUE = 'All Notes'
export const BADGE_SELECT_FIELD_NAME = 'badge-filter'

export const NOTES_SUBJECTS = ['General', 'Alert', 'Medical', 'Financial', 'Schedule']
